import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import {AuthService}from '../../../../auth-guard/auth.service';
// import {dataTableConfig} from '../../../shared/components/datatableconfig';
import { ReplaySubject, Subject, from } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import * as moment from 'moment';
interface  locationarr {};
interface  shipingarr  {};
export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

// const ELEMENT_DATA: PeriodicElement[] = [
//   {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
//   {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
//   {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
//   {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
//   {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
//   {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
//   {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
//   {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
//   {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
//   {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
// ];

@Component({
  selector: 'app-fccp-home',
  templateUrl: './fccp-home.html',
//   styleUrls:['./fccp-layout.scss']
})
export class Fccphome implements OnInit {
  booking_fdl:FormGroup;
  locationarr:any=[];
  shipingarr:any=[];
  userdtl:any;
  paramdata:any;
  chassistypearr:any=[];
  qty:any;
  today:any;
  nextDay:any;
  minDate:any;
  maxDate:any;
  holidays:any=[];
  shutparm_val:any;
  bccemail:any;

  showcontainerid:boolean=false;
  myFilter:any;
  displayedColumns: string[] = ['Location', '20 STD', '40 STD', '45 STD', ];
  dataSource :any=[];
  private _onDestroy = new Subject<void>();
    public filtered_locations: ReplaySubject<locationarr[]> = new ReplaySubject<locationarr[]>(1);
    public filtered_shiping: ReplaySubject<shipingarr[]> = new ReplaySubject<shipingarr[]>(1);
  constructor(private fb: FormBuilder, private router: Router, private authservice: AuthService) {
    this.userdtl=this.authservice.getstoragedtl();
     
    this.intform();
    this.getpickuplocation();
    this.getshiping();
    this.getFeatureDate();
    this.getinventory();
    this.getbccemails();
    this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
    this.booking_fdl.get('truckerscac').setValue(this.userdtl.customer_id);
    // this.booking_fdl.get('customer_type').setValue(this.userdtl.user_role)

    if(this.userdtl.customer_id=='AIMA')
    {
    
      this.booking_fdl.get('truckerscac').enable();
      this.booking_fdl.get('shipping_line').enable();
    }
    else{
      
      this.booking_fdl.get('truckerscac').disable();
      this.booking_fdl.get('shipping_line').disable();
    }
  }
  resetform()
  {
    this.booking_fdl.get('location_cd').setValue(this.locationarr[0].parm_cd);
    // this.booking_fdl.get('user_email').setValue(this.userdtl.user_id);
    this.booking_fdl.get('truckerscac').setValue(this.userdtl.customer_id);

  }
  intform()
  {
    var pickdt = new Date();
    if(pickdt.getDay() == 6){ pickdt = new Date(pickdt.setDate(pickdt.getDate() + 2));}
    if(pickdt.getDay() == 0){ pickdt = new Date(pickdt.setDate(pickdt.getDate() + 1));}
    
    this.booking_fdl = this.fb.group({
      location_cd:'AIMLAX',
      location_cd_ctrl:'',
      truckerscac:['', [Validators.required]],
      user_email:['', [ Validators.email]],
      pickupdate:[pickdt, [Validators.required]],
      chassistype:'',
      quantity:'',
      shipping_line:'',
      shipping_line_ctrl:''
    });
  }
  ngOnInit() {
    // this.intform();
    // this.getpickuplocation();
  }


getpickuplocation()
{
  this.paramdata={};
  this.paramdata.qtype  =  "PGROUP" , 
  this.paramdata.qvalue  =  "BKLCPL"
 
  this.authservice.selectdata('getparameterbycode', this.paramdata).subscribe((getData:any) =>
  {
      if(getData.length > 0)
      {
          this.locationarr=getData;
          this.controllervaluechange(this.locationarr ,'location_cd_ctrl',this.filtered_locations );
          this.booking_fdl.get('location_cd').setValue(this.locationarr[0].parm_cd);
          this.readChassisType();

      }
  },
  onerror => 
  {
  console.log("Error man"); 
  });
}

getshiping()
{
      this.paramdata={};
      this.paramdata.category='FCCPSSL'; 

      this.authservice.selectdata('getreferencecodes', this.paramdata).subscribe((getData:any) =>
      { 
        this.shipingarr=getData
        this.controllervaluechange(this.shipingarr ,'shipping_line_ctrl',this.filtered_shiping );
        this.booking_fdl.get('shipping_line').setValue('ONEY');
      },
      onerror => 
      {
      console.log("Error man"); 
      });

 }

controllervaluechange(elementdata,ctrlname,filteredvar )
{
  filteredvar.next(elementdata.slice());
  this.booking_fdl.get(ctrlname).valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filterdata(elementdata,ctrlname,filteredvar );
              });
}
emailsending(bccemail)
{ 
        this.bccemail=bccemail
        this.paramdata={};
        this.paramdata.qtype="PGROUP";
        this.paramdata.qvalue="BKGEML";
        this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((data:any)=>
         { 
          if(data.length>0)
          {
            for(var i=0;i<data.length;i++)
            {
                if(this.booking_fdl.get('location_cd').value==data[i].parm_cd)
                {
                   
                   this.bccemail += '|'+data[i].parm_value;
                    
                }
            }
          }
          return this.bccemail;
         },
         onerror => { 
                     console.log("Error man in bcc email"); 
                    })
}

getbccemails()
    {
      
              this.paramdata={};
              this.bccemail = "";
              this.paramdata.qtype="PGROUP";
              this.paramdata.qvalue="BEB";
            

        this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((getData:any)=>
        {
        
                for(var i=0 ; i<getData.length ; i++)
                {
                    this.bccemail +=  getData[i].parm_value+'|'; 
                }
                    this.bccemail = this.bccemail.slice(0, -1);
                    // console.log(this.bccemail);
        },
      onerror => { 

                  console.log("Error man"); 
                  });


                        
}
filterdata(elementdata,ctrlname,filteredvar)
{

      if (! elementdata) {
          return;
        }
        // get the search keyword
        let search = this.booking_fdl.get(ctrlname).value;


        if (!search) {
          filteredvar.next( elementdata.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        // filter the sasc
          if(ctrlname=='location_cd_ctrl')
          {
          filteredvar.next(
              elementdata.filter(location_data => (location_data.parm_value).toLowerCase().indexOf(search) > -1)
            );

          }else if(ctrlname=='shipping_line_ctrl')
          {
            filteredvar.next(
              elementdata.filter(shiping_data => (shiping_data.codetxt).toLowerCase().indexOf(search) > -1)
            );
          }
      
    
    
}

readChassisType(){
  
  this.getholidays(this.booking_fdl.get('location_cd').value );
  
  this.paramdata={}
  this.paramdata.location   = this.booking_fdl.get('location_cd').value ;

  this.authservice.selectdata('getpoolEquipmentsizetypes',this.paramdata).subscribe((getData:any) => 
  { 

    if(this.booking_fdl.get('truckerscac').value == "IMCG")
          {

        
            for(var i=0;i<getData.length;i++)
            {
              if(getData[i].eqsz_category == 'SPL')

              {
                
                this.chassistypearr=[]
                this.chassistypearr.push(getData[i]);
                
                this.booking_fdl.get('chassistype').setValue(this.chassistypearr[0].equipment_sztp);
                
              }
            }

          }
          else{

          
            this.chassistypearr = getData ;         
            this.booking_fdl.get('chassistype').setValue(getData[0].equipment_sztp);
          }
          this.readquantity();

  },
  onerror => 
  {
    console.log("Error man"); 
  }); 
}

readquantity()
{
  this.qty = []; 
  var max_cap_val;
 
  // this.shutparm_val='N';

  for( var i=0 ; i<this.chassistypearr.length ; i++)
  {
     if(this.chassistypearr[i].equipment_sztp==this.booking_fdl.get('chassistype').value)
     {
        max_cap_val= this.chassistypearr[i].max_cap_val;
        // this.shutparm_val= this.chassistypearr[i].shut_flg;
     }
  }
   
  for(var j=1;j<= max_cap_val ; j++)
 {
   this.qty.push(j);
 }
 this.booking_fdl.get('quantity').setValue(this.qty[0].toString());
 if(this.booking_fdl.get('quantity').value == '1' ) 
   {
       this.showcontainerid=true;
   }
 
//  console.log('max_cap_val'+max_cap_val);
}

getFeatureDate(){  

  var disabledate;   
  this.paramdata={} ;
  this.paramdata.qtype  = "PCODEPGROUP"  ;
  this.paramdata.qvalue = "FTDAYS|BKG" ;
  this.authservice.selectdata('getparameterbycode',this.paramdata).subscribe((getData:any)=> 
    {

          
            disabledate=getData[0].parm_value;
            var cur_date=  new Date(new Date().getTime() - (7 * 60 * 60 * 1000));
            
            var day_val=cur_date.getDay();
            var org_time=cur_date.toISOString().toString().substr(11,2);
            var current_time=new Date().toISOString().toString().substr(11,2);
            var org_cur_date=new Date();
              if(org_time>current_time) 
              {
                day_val=day_val-1;
              }
          // console.log(day_val);
      
              if(day_val<1 || day_val>5)
              {
                      var check=2;
                      if(day_val==0)
                      {
                        check=1;
                      }
                      disabledate=(getData[0].parm_value-check);
                        if(parseInt(current_time) >= 0 && cur_date.getDay()==1)
                        {
                            this.today=org_cur_date;
                            this.nextDay = new Date(this.today );
                          
                            this.nextDay.setDate(this.today.getDate()+parseInt(disabledate));
                        }
                        else
                        {
                              this.today=org_cur_date;
                              this.nextDay = new Date(this.today );
                              this.nextDay.setDate(this.today.getDate()+check);
                              this.today=this.nextDay;
                              this.nextDay = new Date(this.today );
                              this.nextDay.setDate(this.today.getDate()+parseInt(disabledate));
                        }
            
                }
                else
                {
                    this.today    =  (new Date(new Date().getTime() - (7 * 60 * 60 * 1000)).toISOString()).toString().substr(0,10);
                    this.nextDay = new Date(org_cur_date);
                    this.nextDay.setDate(new Date().getDate()+parseInt(getData[0].parm_value));
                }


                
                this.today=moment(this.today).format('DD-MM-YYYY') ;     
                this.nextDay=moment(this.nextDay).format('DD-MM-YYYY');
                // console.log("todaydate"+this.today+"nextDay"+ this.nextDay);
              
            
            this.minDate = new Date(parseInt(this.today.split("-")[2]) , parseInt(this.today.split("-")[1])-1 , parseInt(this.today.split("-")[0]));
            this.maxDate = new Date(parseInt(this.nextDay.split("-")[2]) , parseInt(this.nextDay.split("-")[1])-1 , parseInt( this.nextDay.split("-")[0]));

            //  console.log("mindate"+ this.minDate);
            //  console.log("maxDate"+ this.maxDate);
      },            
      onerror => {
        console.log("Error man");             
      });

}

getholidays(location)
{
     
        this.paramdata={};
      
        this.paramdata.test= 'test'  ;
        this.paramdata.location= location ;
        this.authservice.selectdata('getbookingholidays',this.paramdata).subscribe((getData:any)=>
        {
        for(var i=0 ; i<getData.length ; i++)
        {
          this.holidays.push((new Date(getData[i].holiday).getTime()));
        }
    
        this.myFilter = (d: Date): boolean => {
          d.setHours(0,0,0,0);
    // Prevent Saturday and Sunday from being selected.
          if(d.getDay() == 0 || d.getDay() == 6)
          {
            return false;
          }
          else if( this.holidays.indexOf(d.getTime()) > -1)
          {
                return false;
          }
          else
          {
                return true;
          }
      
      
        }
      },
    onerror => { 
    
            console.log("Error man"); 
            });
}

getinventory()
{
      this.paramdata={};
      this.authservice.selectdata('getfccpinventory', this.paramdata).subscribe((getData:any) =>
      { 
        console.log(getData);
        this.dataSource=getData;
       
      },
      onerror => 
      {
      console.log("Error man"); 
      });

 }

 bookingrequest(){
  this.paramdata={}
  this.paramdata.customer_id   = this.booking_fdl.get('truckerscac').value ;
  this.authservice.selectdata('customertype',this.paramdata).subscribe((dataread:any) => 
  {  
    if(dataread.length > 0)
    {
      var customer_type = dataread[0].customer_type;
      if( customer_type =="" )
      {
        this.authservice.showToasterror('top-full-width','Trucker Role Not Selected.',3000) ; 
        this.booking_fdl.get('truckerscac').setErrors({customer_type:true});
      }
      else 
      {
        this.paramdata={}
        this.shutparm_val='N';
        this.paramdata.truckerscac=this.booking_fdl.get('truckerscac').value;
        this.paramdata.location=this.booking_fdl.get('location_cd').value;
        for( var i=0 ; i<this.chassistypearr.length ; i++)
        {
            if(this.chassistypearr[i].equipment_sztp==this.booking_fdl.get('chassistype').value)
            {
                this.shutparm_val= this.chassistypearr[i].shut_flg;
            }
        }
        this.authservice.selectdata('getTruckDetails',this.paramdata).subscribe((dataread:any) => 
        {  
          var check=true;
          if(dataread.length>0 )
          {
                var status=dataread[0].status_cd; 
                if(status=='Approved')
                {
                    var pickupdate       = this.booking_fdl.get('pickupdate').value;
                    var insurance        = dataread[0].insurance_exp_dt_short;
                    var fromdate         = insurance.split("-");
                    var finalconfromdate = fromdate[0] + '/' + fromdate[1] + '/' + fromdate[2];
                  
                    var newfromdate     = new Date(finalconfromdate) ;
                    var newtodate       = pickupdate ;
                    var timeDiff        = (newfromdate.getTime() - newtodate.getTime()); 
                    var diffDays        = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1; 

                    if ( diffDays <= 0 )
                    {
                      check=false;
                      this.authservice.showToasterror('top-full-width','Your account is denied due to expired insurance, please have your insurance agent submit updated insurance to uiia@intermodal.org',7000) ; 
                    }

                }
                else if(status=='Pending')
                {
                  check=false; 
                  this.authservice.showToasterror('top-full-width','Trucker is not yet approved to book an AIM chassis.',4000) ; 
                }
                else if(status=='Denied')
                {
                  check=false; 
                  this.authservice.showToasterror('top-full-width','Your account is denied due to expired insurance, please have your insurance agent submit updated insurance to uiia@intermodal.org',7000) ; 
                }
                else if(status=='SHUT OFF')
                {
                  check=false; 
                  this.authservice.showToasterror('top-full-width','Your account is denied due to past due invoices, please contact accountsreceviable@flexivan.com for further details',4000) ; 
                }
                else
                {

                  check=false; 
                  this.authservice.showToasterror('top-full-width','Trucker is not yet approved to book an AIM chassis.',4000) ; 
                  
                }
          }      
        else
          {
            check=false;
            this.authservice.showToasterror('top-full-width','Trucker is not approved yet. Please contact Customer Service at 602-360-1153.',4000) ; 
          }
            
          status = 'A' ;
          var str_chassistype=this.booking_fdl.get('chassistype').value;
        
        if(this.shutparm_val=='Y')
        {
          status='P'; 
        }
        var ts = new Date().getTime();
        if(check==true)
        {
          this.paramdata={};
    
          this.paramdata.booking_from  = "POOL";
          this.paramdata.truckerscac   = this.booking_fdl.get('truckerscac').value;
          this.paramdata.pickupdate    = this.booking_fdl.get('pickupdate').value;
          this.paramdata.chassistype   = str_chassistype;
          this.paramdata.quantity      = this.booking_fdl.get('quantity').value;
          this.paramdata.comments      = ''; 
          this.paramdata.customer_id   = this.userdtl.customer_id;
          this.paramdata.userid        = this.userdtl.user_id;                                                 
          this.paramdata.location_cd   = this.booking_fdl.get('location_cd').value;
          this.paramdata.customer_type = customer_type ;
          this.paramdata.shift_cd      = 'Day Shift';
          this.paramdata.ordernumber   = '';
          this.paramdata.ipaddress     = ''; 
          this.paramdata.status = status;
          this.paramdata.poolcode = 'FCCP';
          this.paramdata.shipline = this.booking_fdl.get('shipping_line').value;
// get ipaddress http://api.ipify.org/?format=json
          this.authservice.selectdata('bookingtrucksp',this.paramdata).subscribe((data:any)=> 
          {
            // this.bccemail=this.emailsending(this.bccemail);
            if(data.length>0 && data[0].result_cd=='S')
            {
              //var action=action_email;
                var action='bookingconformationemail';
                
                if(this.booking_fdl.get('location_cd').value=='SEACGB')
                {
                    action='bookingconformationemail_conglobal';
                }

                var bookingconformation = 
                {
                          action       : action,
                          emailid      : this.booking_fdl.get('user_email').value , 
                          username     : this.userdtl.first_name , 
                          order_nbr    : data[0].bkg_order_nbr , 
                          chassistype  : this.booking_fdl.get('chassistype').value , 
                          quantity     : this.booking_fdl.get('quantity').value ,  
                          pickupdate   : moment(this.booking_fdl.get('pickupdate').value).format('DD-MMM-YYYY')  ,
                          truckerscac  : this.booking_fdl.get('truckerscac').value ,
                          bccemail     : this.bccemail ,
                          status       : status,
                          location     : this.booking_fdl.get('location_cd').value ,
                };
                this.resetform();
                if(status=='A')
                {
                  this.authservice.showSuccess('top-full-width','Your Booking Confirmation Number Is : ' + bookingconformation.order_nbr + '. Please Check Your Email For More Instructions',10000) ; 
                }
                else
                {
                  this.authservice.showSuccess('top-full-width','Your booking request is pending. Please check your email for more details.',10000) ;  
                }
                this.authservice.emailsending("_jsbookingverification.php",bookingconformation ).subscribe((getData:any) => 
                {

                      // if(status=='A')
                      // {
                      //   this.authservice.showSuccess('top-full-width','Your Booking Confirmation Number Is : ' + bookingconformation.order_nbr + '. Please Check Your Email For More Instructions',2000) ; 
                      // }
                      // else
                      // {
                      //   this.authservice.showSuccess('top-full-width','Your booking request is pending. Please check your email for more details.',2000)
                        
                      // }

                },
              onerror => {
                    console.log("Error man in bookingverfication"); 
                });


            }
            else if(data.length>0 && data[0].result_cd=='E')
            {
              this.authservice.showToasterror('top-full-width',data[0].result_txt,3000) ; 
            }
            else
            {
              this.authservice.showToasterror('top-full-width','NOT  Booked The Truck.',2000) ; 
            }
          },
          onerror => 
          {
            this.authservice.showToasterror('top-full-width','NOT  Booked The Truck.',2000) ;
            console.log("Error man in bookingtrucksp"); 
          });
        }
      },
      onerror => 
      {
            console.log("Error man in TruckDetails"); 
      });

      }
    }
    else{
      this.authservice.showToasterror('top-full-width','Trucker Role Not Selected.',2000) ;
      this.booking_fdl.get('truckerscac').setErrors({customer_type:true});
    }
  },
  onerror => 
  {
    console.log("Error man in customer_type"); 
  });

}


}
